/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Archived_SuccessInputs */

const en_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job archived successfully`)
};

const fr_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche archivée avec succès`)
};

const de_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftrag erfolgreich archiviert`)
};

const it_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro archiviato con successo`)
};

const ru_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание успешно завершено.`)
};

const es_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo archivado exitosamente`)
};

const zh_cn2_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`职位已成功归档`)
};

const ja_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブは正常にアーカイブされました`)
};

const hi_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी सफलतापूर्वक संग्रहीत हो गई`)
};

const pt_pt2_job_archived_success = /** @type {(inputs: Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa arquivada com sucesso`)
};

/**
* | output |
* | --- |
* | "Job archived successfully" |
*
* @param {Job_Archived_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_archived_success = /** @type {((inputs?: Job_Archived_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Archived_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_job_archived_success(inputs)
	if (locale === "de") return de_job_archived_success(inputs)
	if (locale === "it") return it_job_archived_success(inputs)
	if (locale === "ru") return ru_job_archived_success(inputs)
	if (locale === "es") return es_job_archived_success(inputs)
	if (locale === "zh-CN") return zh_cn2_job_archived_success(inputs)
	if (locale === "ja") return ja_job_archived_success(inputs)
	if (locale === "hi") return hi_job_archived_success(inputs)
	if (locale === "pt-PT") return pt_pt2_job_archived_success(inputs)
	return en_job_archived_success(inputs)
});